const styles = theme => ({
	root: {
	},

	disableGutters: {
		paddingLeft: 0,
		paddingRight: 0,
	},

	icon: {
		fill: '#009AC9',
	},

	icons: {
		display: 'flex',
		alignItems: 'center',
	},

	checkIcon: {
		color: '#51B383',
	},
});

export default styles;